import { render, staticRenderFns } from "./optTechnical.vue?vue&type=template&id=0ea4e640&scoped=true"
import script from "./optTechnical.vue?vue&type=script&lang=js"
export * from "./optTechnical.vue?vue&type=script&lang=js"
import style0 from "./optTechnical.vue?vue&type=style&index=0&id=0ea4e640&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea4e640",
  null
  
)

export default component.exports